
import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../views/Layout.vue'

// 导入页面组件
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import WebBuild from '../views/WebBuild.vue'
import MobileApp from '../views/MobileApp.vue'
import WechatMarketing from '../views/WechatMarketing.vue'
import HardwareDev from '../views/HardwareDev.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {path: 'home', name:'Home', component:Home},
      {path: 'about', name:'About', component:About},
      {path: 'webbuild', name:'WebBuild', component:WebBuild},
      {path: 'mobileapp', name:'MobileApp', component:MobileApp},
      {path: 'wechatmarketing', name:'WechatMarketing', component:WechatMarketing},
      {path: 'hardwaredev', name:'HardwareDev', component:HardwareDev},
    ]
  }
]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
